import { buildHtmlMarkup } from '@/app/utils/html/html';
import type { ComponentNewsHeader } from '@/types/tis-cms/types';

export const HeaderContent = ({ data }: { data: ComponentNewsHeader }) => (
  <h2
    className="text-sub-h2 font-noto-bold"
    dangerouslySetInnerHTML={buildHtmlMarkup(data.text)}
  />
);
